import { render, staticRenderFns } from "./saleschannalItemData.vue?vue&type=template&id=550c7776&scoped=true&"
import script from "./saleschannalItemData.vue?vue&type=script&lang=js&"
export * from "./saleschannalItemData.vue?vue&type=script&lang=js&"
import style0 from "./saleschannalItemData.vue?vue&type=style&index=0&id=550c7776&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "550c7776",
  null
  
)

export default component.exports